import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/price-scale.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/minus.svg';
import debounce from 'lodash/debounce';
import { SLOW_TIMER } from '~/const/timers';
var VueSlider = {};

if (process.browser) {
  // eslint-disable-next-line
  VueSlider = require('vue-slider-component');
}

export default {
  name: 'RangeFilter',
  components: {
    VueSlider: VueSlider
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    desktopLayer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref3, _ref4, _ref5, _ref6;

    return {
      values: [((_ref6 = this.filter) != null ? (_ref6 = _ref6.facets) != null ? (_ref6 = _ref6.selected) != null ? _ref6.min : _ref6 : _ref6 : _ref6) || this.filter.facets.min, ((_ref5 = this.filter) != null ? (_ref5 = _ref5.facets) != null ? (_ref5 = _ref5.selected) != null ? _ref5.max : _ref5 : _ref5 : _ref5) || this.filter.facets.max],
      inputValues: [((_ref4 = this.filter) != null ? (_ref4 = _ref4.facets) != null ? (_ref4 = _ref4.selected) != null ? _ref4.min : _ref4 : _ref4 : _ref4) || this.filter.facets.min, ((_ref3 = this.filter) != null ? (_ref3 = _ref3.facets) != null ? (_ref3 = _ref3.selected) != null ? _ref3.max : _ref3 : _ref3 : _ref3) || this.filter.facets.max],
      options: {
        height: 2,
        enableCross: false,
        dotSize: 32,
        min: this.filter.facets.min,
        max: this.filter.facets.max,
        minRange: 1,
        lazy: true,
        tooltip: 'none',
        processStyle: {
          backgroundColor: '#c4a181'
        },
        railStyle: {
          backgroundColor: '#9B9B9B'
        }
      }
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    tracking: function tracking() {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Filtre_Prix',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    }
  }),
  watch: {
    filter: function filter() {
      var _ref, _ref2;

      this.values = [((_ref2 = this.filter) != null ? (_ref2 = _ref2.facets) != null ? (_ref2 = _ref2.selected) != null ? _ref2.min : _ref2 : _ref2 : _ref2) || this.filter.facets.min, ((_ref = this.filter) != null ? (_ref = _ref.facets) != null ? (_ref = _ref.selected) != null ? _ref.max : _ref : _ref : _ref) || this.filter.facets.max];
    }
  },
  methods: _objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY'
  }), {
    previewPriceOnInputInstantly: function previewPriceOnInputInstantly(values) {
      if (Array.isArray(values) && values.length >= 2) {
        this.inputValues = [values[0], values[1]];
      }
    },
    formatterCurrency: function formatterCurrency(value) {
      var formattedPrice = new Intl.NumberFormat(this.locale.iso, {
        style: 'currency',
        currency: this.locale.currency,
        maximumSignificantDigits: 3
      }).format(value);
      return formattedPrice;
    },
    format: function format() {
      var _this = this;

      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var result = value;

      if (global.Intl) {
        if (Array.isArray(result)) {
          result = result.map(function (i) {
            return _this.formatterCurrency(i);
          }).join(' - ');
        } else {
          result = this.formatterCurrency(value);
        }
      }

      return result;
    },
    applyPriceRangeChange: function applyPriceRangeChange() {
      this.inputValues = [this.values[0], this.values[1]];
      this.filterBy({
        filter: 'price',
        facet: this.values.join('-'),
        uniq: true
      });
      this.$root.$emit('generic-tracking', '', this.tracking);
    },
    restrictNumbers: function restrictNumbers(event) {
      return event.charCode >= 48 && event.charCode <= 57 ? true : event.preventDefault();
    },
    handlePriceInput: debounce(function checkInput() {
      this.inputValues = [parseInt(this.inputValues[0], 10), parseInt(this.inputValues[1], 10)];
      var values = [parseInt(this.values[0], 10), parseInt(this.values[1], 10)];
      if (!this.inputValues[0] || this.inputValues[0].length === 0 || this.inputValues[0] < parseInt(this.filter.facets.min, 10) || this.inputValues[0] >= values[1]) this.inputValues = [parseInt(this.filter.facets.min, 10), this.inputValues[1]];
      if (!this.inputValues[1] || this.inputValues[1].length === 0 || this.inputValues[1] > parseInt(this.filter.facets.max, 10) || this.inputValues[1] <= values[0]) this.inputValues = [this.inputValues[0], parseInt(this.filter.facets.max, 10)];

      if (this.inputValues[0] !== values[0] || this.inputValues[1] !== values[1]) {
        this.values = [this.inputValues[0], this.inputValues[1]];
        this.applyPriceRangeChange();
      }
    }, SLOW_TIMER)
  })
};